// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';
import wysiwyg from 'vue-wysiwyg';
import '../node_modules/vue-wysiwyg/dist/vueWysiwyg.css';

// font awesome libs
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck, faFileDownload, faSpinner, faSort, faPoll, faInfo, faEdit, faTrash, faCaretDown, faCaretUp, faClone, faCopy
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import router from './router';
import App from './App.vue';

Vue.use(VueResource);
Vue.use(require('vue-moment'));

Vue.use(wysiwyg, {});

Vue.use(BootstrapVue);

// more fontawesome stuff
library.add(faCheck, faFileDownload, faSpinner, faSort, faPoll, faInfo, faEdit, faTrash, faCaretDown, faCaretUp, faClone, faCopy);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    token: null,
    SURVEY_MONKEY_URL: process.env.SURVEY_MONKEY_URL,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    API_ENDPOINT: process.env.API_ENDPOINT
  }
});



// WEBPACK FOOTER //
// ./src/main.js